import { Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { AdminGuard } from './shared/guards/admin.guard';
import { ValetGuard } from './shared/guards/valet.guard';
import { CustomerGuard } from './shared/guards/customer.guard';
import { RedirectGuard } from './shared/guards/redirect.guard';

// Define the two possible route configurations
const recruitmentRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pv-modules/pv-recruitment/pv-recruitment.routes')
      .then(m => m.routes),
  },
  {
    path: 'inscription',
    canMatch: [AuthGuard, ValetGuard],
    loadChildren: () => import('./valet/valet.routes')
      .then(m => m.routes),
  },
];

const mainRoutes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes')
      .then(m => m.routes),
  },
  {
    path: 'client',
    canActivate: [AuthGuard, ValetGuard],
    loadChildren: () => import('./valet/valet.routes')
      .then(m => m.routes),
  },
  {
    path: 'customer',
    canActivate: [AuthGuard, CustomerGuard],
    loadChildren: () => import('./client/client.routes')
      .then(m => m.routes),
  },
  {
    path: 'admin',
    canMatch: [AuthGuard, AdminGuard],
    loadChildren: () => import('./admin/admin.routes')
      .then(m => m.routes),
  },
  {
    path: 'reservation',
    loadChildren: () => import('./pv-modules/pv-reservation/pv-reservation.routes')
      .then(m => m.routes),
  },
  {
    path: 'subcontractor',
    loadChildren: () => import('./pv-modules/pv-subcontractor/pv-subcontractor.routes')
      .then(m => m.routes),
  },
  {
    path: 'mission-data',
    loadChildren: () => import('./common-modules/common-mission-data/common-mission-data.routes')
      .then(m => m.routes),
  },
  {
    path: 'mission-tracking',
    loadChildren: () => import('./pv-modules/pv-mission-tracking/pv-mission-tracking.routes')
      .then(m => m.routes),
  },
  {
    path: '',
    pathMatch: 'full',
    children: [],
    canActivate: [RedirectGuard]
  }
];

// Determine routes based on hostname
export const routes: Routes = window.location.hostname.startsWith('recrutement') 
  ? recruitmentRoutes 
  : mainRoutes;